// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header_header__j-9P6 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  background: var(--dylo-surface);
  border: var(--dylo-card-border-width) solid var(--dylo-surface-border);
  border-radius: 16px;
  box-shadow: var(--shadow-card);
  padding: 16px 22px;
}

.Header_welcome__rvM-5 {
  font-size: 17px;
  font-weight: 600;
  color: var(--dylo-ink);
  margin: 0;
}
.Header_name__vnSTa {
  color: var(--dylo-orange);
}

.Header_actions__XB8KQ {
  display: flex;
  align-items: center;
  gap: 10px;
}

/**
 * MÓVIL: el header usa \`space-between\` sin \`flex-wrap\`, así que el saludo, las
 * acciones de la página y el menú de usuario se apretaban en una sola línea a
 * 430px. Aquí se permite que bajen de renglón y se reduce el padding.
 */
@media (max-width: 720px) {
  .Header_header__j-9P6 {
    flex-wrap: wrap;
    gap: 12px;
    padding: 14px 16px;
  }
  .Header_welcome__rvM-5 {
    font-size: 15.5px;
  }
  .Header_actions__XB8KQ {
    flex-wrap: wrap;
  }
}

/* Header reemplazado por una página (ej. Loads status cards) */
.Header_headerCustom__rVhJq {
  width: 100%;
}

.Header_resetBtn__QV2O2 {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #1f1f1f;
  color: #fff;
  border: none;
  border-radius: 999px;
  padding: 9px 18px;
  font-family: var(--font-sans);
  font-size: 13.5px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.15s ease;
}
.Header_resetBtn__QV2O2:hover {
  background: #000;
}
`, "",{"version":3,"sources":["webpack://./src/v2/layout/Header.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,+BAA+B;EAC/B,sEAAsE;EACtE,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;;;;EAIE;AACF;EACE;IACE,eAAe;IACf,SAAS;IACT,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;AACF;;AAEA,+DAA+D;AAC/D;EACE,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,uCAAuC;AACzC;AACA;EACE,gBAAgB;AAClB","sourcesContent":[".header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  background: var(--dylo-surface);\n  border: var(--dylo-card-border-width) solid var(--dylo-surface-border);\n  border-radius: 16px;\n  box-shadow: var(--shadow-card);\n  padding: 16px 22px;\n}\n\n.welcome {\n  font-size: 17px;\n  font-weight: 600;\n  color: var(--dylo-ink);\n  margin: 0;\n}\n.name {\n  color: var(--dylo-orange);\n}\n\n.actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n/**\n * MÓVIL: el header usa `space-between` sin `flex-wrap`, así que el saludo, las\n * acciones de la página y el menú de usuario se apretaban en una sola línea a\n * 430px. Aquí se permite que bajen de renglón y se reduce el padding.\n */\n@media (max-width: 720px) {\n  .header {\n    flex-wrap: wrap;\n    gap: 12px;\n    padding: 14px 16px;\n  }\n  .welcome {\n    font-size: 15.5px;\n  }\n  .actions {\n    flex-wrap: wrap;\n  }\n}\n\n/* Header reemplazado por una página (ej. Loads status cards) */\n.headerCustom {\n  width: 100%;\n}\n\n.resetBtn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: #1f1f1f;\n  color: #fff;\n  border: none;\n  border-radius: 999px;\n  padding: 9px 18px;\n  font-family: var(--font-sans);\n  font-size: 13.5px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.15s ease;\n}\n.resetBtn:hover {\n  background: #000;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `Header_header__j-9P6`,
	"welcome": `Header_welcome__rvM-5`,
	"name": `Header_name__vnSTa`,
	"actions": `Header_actions__XB8KQ`,
	"headerCustom": `Header_headerCustom__rVhJq`,
	"resetBtn": `Header_resetBtn__QV2O2`
};
export default ___CSS_LOADER_EXPORT___;
